// hooks/useFamilyMembers.ts

import { FamilyMember } from "../../interfaces/DTO/crm/family";
import { familyMemberService } from "../../services/crm/familyMemberService";
import { createCachedEntityHooks } from "../createEntityHooks";

// ✅ hook-ים מותאמים עם שאילתות לפי שדות בלבד (ללא cache לפי ID)
export const {
  useAll: useAllFamilyMembers, // ⬅️ תוודא שזה קיים
  useEntityListByField: useEntityListByField,
  useEntityById: useFamilyMemberById,
  useEntityByIds: useFamilyMemberByIds,
  useCreateEntity: useCreateFamilyMember,
  useUpdateEntity: useUpdateFamilyMember,
  usePartialUpdateEntity: usePartialUpdateFamilyMember,
  useDeleteEntity: useDeleteFamilyMember,
} = createCachedEntityHooks<FamilyMember>({
  entityName: "familyMembers",
  service: familyMemberService,
  enableCacheById: true,
  staleTimeMs: 5 * 60 * 1000,
  fieldIndexes: {
    family_id: () => (familyId: number) =>
      familyMemberService.fetchFamilyMembersByFamily(familyId),
  },
});

// עטיפות קריאות יותר בעברית
export const useFamilyMembersByFamily = (familyId: number, enabled: boolean = true) =>
  useEntityListByField("family_id", familyId, enabled && !!familyId);

